import BaseListPresenter from "../../../base/BaseListPresenter";
import { toCamelCase } from "../Payroll/helper-payroll/HelperFunction";
import * as XLSX from "xlsx";

class ContributionPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
    this.filteredObjects = [];
  }
  init() {
    this.limit = 50;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterForMonth = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.filteredObjects = [];
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterForMonth,
      },
      include: this.include,
    };

    console.log("QUERYYY", query);
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  _onSelect(field, value) {
    let selectedItem = this.view.state.selectedItem || [];

    const formattedValue = field === "month" ? value : toCamelCase(value);

    // Determine group logic (type or month)
    const isMonth = field === "month";

    // Remove value logic
    if (formattedValue === "") {
      selectedItem = selectedItem.filter((item) => {
        // Remove only month value
        if (isMonth) {
          return !this._isMonth(item);
        } else {
          return !this._isType(item);
        }
      });
    } else {
      // Remove previous value from the same group
      selectedItem = selectedItem.filter((item) => {
        if (isMonth) {
          return !this._isMonth(item);
        } else {
          return !this._isType(item);
        }
      });

      // Add new one
      selectedItem.push(formattedValue);
    }

    console.log("SELECTEDDDD ITEM", selectedItem);
    console.log("FORMATTTEDDD VALUEE", formattedValue);
    this.view.setState({ [field]: value, selectedItem });

    if (isMonth) {
      this._onChangeFilter("array", formattedValue, "monthForContributions");
    } else {
      this._onChangeFilter("array", formattedValue, "mandatoryDeductions");
    }
  }

  // Helper to detect months
  _isMonth = (value) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.includes(value);
  };

  // Helper to detect type (everything that's not a month)
  _isType = (value) => {
    return !this._isMonth(value);
  };

  _onChangeFilter = (type, value, field) => {
    const where = { ...this.view.state.filters };

    console.log("VALUEEEE", value);
    console.log("FIELDDD", field);

    // Apply the new filter
    switch (type) {
      case "array":
        if (value) {
          where[field] = {
            $elemMatch: { $regex: value, $options: "i" },
          };
        } else {
          delete where[field];
        }
        break;
      default:
        if (value) {
          where[field] = { $regex: value, $options: "i" };
        } else {
          delete where[field]; // Remove filter if no value
        }
    }

    console.log("where", where);
    this.view.setState({ filters: where }, () => {
      if (field === "monthForContributions") {
        this.filterSubmitForMonth(this.view.state.filters);
      } else {
        this.filterSubmit(this.view.state.filters);
      }
    });
  };

  filterSubmitForMonth(where) {
    localStorage.removeItem("currentPage");
    this.reset();
    this.filterForMonth = where;
    this.getObjects();
  }

  _handleExportCsv(includeLabel, objects) {
    const { month } = this.view.state;
    const schema = this.view.getSchema(this.view.getCollectionName());
    const label = this._getExportLabels(schema, includeLabel);

    const processedData = objects.map((obj) => {
      const rowObj = { ...obj };
      const processedRow = {};

      label.forEach(({ key, label: headerLabel }) => {
        let val = rowObj[key];

        if (Array.isArray(val) && month && month !== "") {
          val = val.filter((item) =>
            item.toLowerCase().includes(month.toLowerCase())
          );
        }

        processedRow[headerLabel] =
          val == null ? "" : Array.isArray(val) ? val.join("\n") : String(val);
      });

      return processedRow;
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(processedData);

    // Set column widths
    const colWidths = label.map(({ label: header }) => {
      const maxWidth = Math.max(
        header.length,
        ...processedData.map((row) => (row[header] || "").length)
      );
      return { wch: Math.min(Math.max(maxWidth + 2, 10), 50) };
    });
    worksheet["!cols"] = colWidths;

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: {
            bold: true,
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
        };
      }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, "Export Data");

    const fileName = `Employee_Contributions_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, fileName, { cellStyles: true });
  }

  _getExportLabels = (schema, includeLabel) => {
    return Object.keys(schema.fields)
      .filter((fieldName) => {
        const config = schema.fields[fieldName];
        return (
          config && config.read !== false && !includeLabel.includes(fieldName)
        );
      })
      .map((fieldName) => ({
        key: fieldName,
        label: schema.fields[fieldName].label || this._camelToLabel(fieldName),
      }));
  };

  _camelToLabel = (str) =>
    str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());
}
export default ContributionPresenter;
